import { lowerFirst } from 'es-toolkit';

function createNonexistentProperty(keyName: string) {
  const throwNonexistentPropertyError = () => {
    throw new Error(`Property does not exist: ${keyName}`);
  };

  return {
    configurable: false,
    enumerable: false,
    get: throwNonexistentPropertyError,
    set: throwNonexistentPropertyError,
  };
}

function normalizeObjectKeys(sourceObject: Record<string, unknown>) {
  const transformedObject: Record<string, unknown> = {};

  for (const key of Object.keys(sourceObject)) {
    let newKey = key;

    if (lowerFirst(key) !== key) {
      newKey = key.length > 2 ? lowerFirst(key) : key.toLowerCase();
      Object.defineProperty(transformedObject, key, createNonexistentProperty(key));
    }

    if (newKey.endsWith('_ID')) {
      newKey = `${newKey.slice(0, newKey.indexOf('_ID'))}Id`;
    }

    transformedObject[newKey] = sourceObject[key];
  }

  return transformedObject;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object';
}

export function normalizeObject(result: unknown): unknown {
  if (Array.isArray(result)) {
    return result.map(normalizeObject);
  }

  if (isObject(result)) {
    for (const key of Object.keys(result)) {
      result[key] = normalizeObject(result[key]);
    }

    return normalizeObjectKeys(result);
  }

  return result;
}
